module.exports = __webpack_public_path__ + "static/ninja-thumbnail-f7e3d0f22cebb24781a81a0d2d536b99.png";